import ServiceGraphQL from 'src/service/gql-service';
import { updateCompany } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateCompany = (variables) => {
  const params = {
    query: updateCompany.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.companiesUpdateOne;
    })
    .catch((err) => {
      throw err;
    });
};
